export default {"rtl":false}
